/**
 * Missions endpoints
 */
export const missionsEndpoints = {
  list: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return `/api/missions${qs}`
  },
  detail: (id) => `/api/missions/${id}`,
  create: () => '/api/missions',
  update: (id) => `/api/missions/${id}`,
  delete: (id) => `/api/missions/${id}`,
  restore: (id) => `/api/missions/${id}/restore`,
  formateursSelectionnes: (id, params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return `/api/missions/${id}/formateurs-selectionnes${qs}`
  },
  diffuser: (id) => `/api/missions/${id}/diffuser`,
  attribuer: (id, formateurId) => `/api/missions/${id}/attribuer/${formateurId}`,
  attribuerPlusieurs: (id) => `/api/missions/${id}/attribuer-plusieurs`,
  tarifCandidat: (id, formateurId) => `/api/missions/${id}/formateurs/${formateurId}/tarif`,
  suggestTarif: (id, formateurId) => `/api/missions/${id}/suggest-tarif/${formateurId}`,
  mapDiffusion: (id) => `/api/missions/${id}/map-diffusion`,
  enrichFormateur: (missionId, formateurId) => `/api/missions/${missionId}/enrich-formateur/${formateurId}`,
  diffuserSelection: (id) => `/api/missions/${id}/diffuser-selection`,
  createAndDiffuse: () => '/api/missions/create-and-diffuse',
  // Onglet « Recherche » : un salarié publie une mission aux formateurs de la zone.
  recherchePublier: () => '/api/missions/recherche',
  rechercheMesPublications: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return `/api/missions/recherche/mes-publications${qs}`
  },
  rechercheSupprimer: (id) => `/api/missions/recherche/${id}`,
  rechercheAnnuler: (id) => `/api/missions/recherche/${id}/annuler`,
  modifierRecherche: (id) => `/api/missions/recherche/${id}`,
  rechercheSuivi: (id) => `/api/missions/recherche/${id}/suivi`,
  // Zone de recherche d'une mission : la lire, compter un élargissement, l'élargir.
  rechercheZone: (id) => `/api/missions/recherche/${id}/zone`,
  rechercheElargissement: (id, rayonKm) => `/api/missions/recherche/${id}/elargissement?rayonKm=${encodeURIComponent(rayonKm)}`,
  rechercheElargir: (id) => `/api/missions/recherche/${id}/elargir`,
  rechercheCommerciaux: () => '/api/missions/recherche/commerciaux',
  rechercheFormations: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return `/api/missions/recherche/formations${qs}`
  },
  rechercheFormateursDisponibles: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return `/api/missions/recherche/formateurs-disponibles${qs}`
  },
  annuler: (id) => `/api/missions/${id}/annuler`,
  reprogrammer: (id) => `/api/missions/${id}/reprogrammer`,
  urgente: (id) => `/api/missions/${id}/urgente`,
  evenements: (id) => `/api/missions/${id}/evenements`,
  byQuote: (quoteId) => `/api/missions/by-quote/${quoteId}`,
  // Post-formation formateur (LOT 6)
  getFormateurPostFormation: (id) => `/api/missions/${id}/formateur-post-formation`,
  renvoyerDemandeFacture: (id) => `/api/missions/${id}/renvoyer-demande-facture`,
  validerEmargement: (id) => `/api/missions/${id}/valider-emargement`,
  confirmerVirement: (id) => `/api/missions/${id}/confirmer-virement`,
  // Conventions formateur (LOT 8)
  generateContrat: (id) => `/api/missions/${id}/generate-contrat`,
  downloadContrat: (id) => `/api/missions/${id}/contrat/download`,
  conventionsStatus: (id) => `/api/missions/${id}/conventions/status`,
  conventionsGenerate: (id) => `/api/missions/${id}/conventions/generate`,
  conventionsResend: (id) => `/api/missions/${id}/conventions/resend`,
  conventionDownload: (id) => `/api/missions/${id}/convention/download`,
  // Public (token email)
  public: {
    getReponse: (token) => `/api/public/missions/reponse?token=${token}`,
    soumettreReponse: () => '/api/public/missions/reponse',
  },
  publicFormateurFacture: {
    getInfo: (token) => `/api/public/formateur-facture?token=${token}`,
    upload: (token) => `/api/public/formateur-facture/upload?token=${token}`,
  },
}
